var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 11,
    viewBox: "0 0 17 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4561 6.1196C16.7077 5.86801 16.7077 5.46011 16.4561 5.20852L12.3563 1.10866C12.1047 0.857075 11.6968 0.857075 11.4452 1.10866C11.1936 1.36025 11.1936 1.76816 11.4452 2.01974L15.0895 5.66406L11.4452 9.30838C11.1936 9.55997 11.1936 9.96787 11.4452 10.2195C11.6968 10.471 12.1047 10.471 12.3563 10.2195L16.4561 6.1196ZM0.539062 6.30829H16.0006V5.01983H0.539062V6.30829Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.2e1b763a38ef5cba135d18843dfb501e.svg";
export { ForwardRef as ReactComponent };